/**
 * Action types for the digital twin slice.
 *
 * Kept in their own module (matching machineOverview.types.js,
 * machineCharts.types.js, machineInfo.types.js, ...) so the reducer can import
 * them without pulling in digitalTwin.actions -> digitalTwin.service ->
 * common/helpers -> app/store, which drags the entire root reducer tree into
 * any consumer and makes the reducer untestable in isolation.
 */
export const digitalTwinActionTypes = {
  FETCH_SCENE_REQUEST: 'DIGITAL_TWIN_FETCH_SCENE_REQUEST',
  FETCH_SCENE_SUCCESS: 'DIGITAL_TWIN_FETCH_SCENE_SUCCESS',
  FETCH_SCENE_FAILURE: 'DIGITAL_TWIN_FETCH_SCENE_FAILURE',
  REORDER_COMPONENTS_REQUEST: 'DIGITAL_TWIN_REORDER_COMPONENTS_REQUEST',
  REORDER_COMPONENTS_SUCCESS: 'DIGITAL_TWIN_REORDER_COMPONENTS_SUCCESS',
  REORDER_COMPONENTS_FAILURE: 'DIGITAL_TWIN_REORDER_COMPONENTS_FAILURE',
  SET_SELECTED_ITEM: 'DIGITAL_TWIN_SET_SELECTED_ITEM',
  SET_EDIT_MODE: 'DIGITAL_TWIN_SET_EDIT_MODE',
  SET_INITIAL_EVENTS: 'DIGITAL_TWIN_SET_INITIAL_EVENTS',
  CLEAR_STATE: 'DIGITAL_TWIN_CLEAR_STATE',
  // The events fetch needs its own *_REQUEST name so the abortControllers
  // reducer in app/reducers.js gives it a controller separate from the scene
  // fetch — sharing one would make each cancel the other.
  FETCH_EVENTS_REQUEST: 'DIGITAL_TWIN_FETCH_EVENTS_REQUEST',
  FETCH_EVENTS_SUCCESS: 'DIGITAL_TWIN_FETCH_EVENTS_SUCCESS',
  FETCH_EVENTS_FAILURE: 'DIGITAL_TWIN_FETCH_EVENTS_FAILURE',
};

export default digitalTwinActionTypes;
